module.exports = __webpack_public_path__ + "static/media/empty.3c78d8d7.svg";